/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Tree from 'avl'

import { BasicComparator, areDeepEqual } from 'fierry/type/compare';


export default class Set
{
  constructor (values = [])
  {
    this.tree = new Tree(BasicComparator, true);

    for (const value of values)
    {
      this.insert(value);
    }
  }


  insert (value)
  {
    this.tree.insert(value);
  }


  remove (value)
  {
    this.tree.remove(value);
  }


  contains (value)
  {
    return this.tree.contains(value);
  }


  at (index)
  {
    const node = this.tree.at(index);

    return node ? node.key : null;
  }


  map (callback)
  {
    let collection = [];

    for (const value of this.tree.keys())
    {
      collection.push(callback(value));
    }

    return collection;
  }


  size ()
  {
    return this.tree.size;
  }


  empty ()
  {
    return this.tree.size === 0;
  }


  toArray ()
  {
    return this.tree.keys();
  }


  deepEquals (rhs)
  {
    if (!(rhs instanceof Set) || this.size() !== rhs.size())
    {
      return false;
    }

    const values = rhs.toArray();

    return this.toArray().every((value, index) =>
    {
      return areDeepEqual(value, values[index]);
    });
  }


  *[Symbol.iterator]()
  {
    for (const value of this.tree.keys())
    {
      yield value;
    }
  }


};
